import React, { useState, useRef } from 'react'
import { Accordion, Button, Container, Form, FormControl, InputGroup, Nav, Row, Col, Tab, OverlayTrigger, Popover, Tooltip } from 'react-bootstrap';
import styles from './Measures.module.scss';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { data } from '../data';
import { useHistory, useParams, useLocation } from 'react-router-dom'
import AccordionHeader from 'react-bootstrap/esm/AccordionHeader';
import AccordionBody from 'react-bootstrap/esm/AccordionBody';
import AccordionItem from 'react-bootstrap/esm/AccordionItem';

const AllMeasures = () => {
    let loc = window.location.hash;
    loc = loc.slice(1);
    const history = useHistory();
    const location = useLocation();
    const [searchTerm, setSearchTerm] = useState('');
    const [copied, setCopied] = useState(false);
    const [show, setShow] = useState(false);
    const [appendix, setAppendix] = useState(false);
    const [shown, setShown] = useState(false);
    const target = useRef(null);
    const [selectedTab, setSelectedTab] = useState(location.search.substring(1));
    const handleSelect = (e) => {
        //set state
        setSelectedTab(e);
        //update url
        history.replace({
            search: `${e}`
        });
    }
    const handleCopy = () => {
        setCopied(true);
    };

    const clickOnButton = () => {
        setShown(true);
    }

    const handleClick = (e) => {
        e.stopPropagation();
        setShow(!show);
        setShown(true);
        setTimeout(() => {
            setShown(false);
        }, 2000);
    };

    const appendixClick = () => {
        setAppendix(true);
        setTimeout(() => {
            setAppendix(false);
        }, 2000);
    }

    const handleClickIndex = (index) => {
        setShow(!show);
        setShown(index);
        setTimeout(() => {
            setShown(false);
        }, 2000);
    };

    const [hover, sethover] = useState(null);

    const handleStop = (e) => {
        e.stopPropagation();
    }

    const handleResetHover = (index) => {
        sethover(false);
    }

    const setHov = (index) => {
        sethover(true);
    }

    const handleMouseEnter = (index) => {
        sethover(index);
        setTimeout(() => {
            sethover(false);
        }, 3000);
    }
    return (<>

        <Container className='outerContainer'>
            <h1 className="centerText mb-5">All Indicators Resources</h1>
            <p>This page contains Quality Indicator's (QI) technical specifications from all four modules. You will be able to browse and search QI definitions and download most current and prior versions of the technical specifications document.</p>
        </Container>
        <Container className="outerContainer">
            <div className={styles.searchContainer}>
                <h3 className={styles.searchHeading}>Filter</h3>
                <Form className="flex">
                    <Form.Group className={styles.search} controlId="formBasicEmail">
                        <InputGroup className={styles.inputGroup}>
                            <FormControl className={styles.searchBox} placeholder="Please enter a search term (i.e. Software, Health, etc...)" onChange={event => { setSearchTerm(event.target.value) }} />
                            <Button className={styles.resetButton} type="reset" onClick={event => { setSearchTerm('') }}>Reset Search</Button>
                        </InputGroup>
                    </Form.Group>
                </Form>
            </div>
        </Container>
        <Container className='outerContainer'>
            <Tab.Container id="left-tabs-example" activeKey={selectedTab ? selectedTab : '1'} onSelect={(e) => handleSelect(e)}>
                <Row>
                    <Col md={3}>
                        <Nav variant="pills" className="flex-column">
                            {data.modules.map((information, index) => (<>
                                <Nav.Item>
                                    <Nav.Link onClick={handleResetHover} eventKey={index + 1}>{information.module}</Nav.Link>
                                </Nav.Item>
                                <hr className="divider-blue"/>
                            </>))}
                        </Nav>
                    </Col>
                    <Col md={9}>
                        {searchTerm == "" ? null : <h5>Showing results for: "{searchTerm}"</h5>}
                        {data.modules.map((information, index) => (<>

                            <Tab.Content className={styles.tabContent}>
                                <Tab.Pane eventKey={index + 1}>

                                    {information.indicators.filter((child) => {
                                        if (searchTerm == "") {
                                            return child
                                        } else if (child.indicator.toLowerCase().includes(searchTerm.toLowerCase())) {
                                            return child
                                        } else if (child.current.description.toLowerCase().includes(searchTerm.toLowerCase())) {
                                            return child
                                        }
                                    }).map((child, index) => (<>
                                        <Accordion id={child.tag} className={styles.faqsAccordion} eventKey={child.tag} defaultActiveKey={loc.length === 0 ? "empty" : loc}>
                                            <Accordion.Item eventKey={child.tag}>
                                                <Accordion.Header id={child.tag} >
                                                    <div className={styles.accordionHeading}>
                                                        <div className={styles.subTopicHeading}>{child.indicator}</div>
                                                        <div ref={target}>
                                                            {hover === index ? <div className={styles.copyContainer}><i className="fa fa-check-circle flex"></i><div className={styles.copiedText + ' ' + "flex"}>Copied to Clipboard</div></div> :
                                                                <CopyToClipboard text={`${window.location.origin}` + `${window.location.pathname}` + "?" + `${selectedTab ? selectedTab : '1'}` + "#" + `${child.tag}`} onCopy={handleCopy}>
                                                                    <Button variant="link" className={styles.copyBtn} onClick={(e) => e.stopPropagation()}>
                                                                        <a onClick={() => handleMouseEnter(index)}>Share</a>
                                                                    </Button>
                                                                </CopyToClipboard>
                                                            }
                                                        </div>

                                                    </div>

                                                </Accordion.Header>
                                                <Accordion.Body>
                                                    <Row className={styles.accordionContent}>
                                                        <Col md={8}>
                                                            <p>
                                                                {child.current.version ?
                                                                    <><h4>{child.current.version}</h4>
                                                                        <h5>{child.current.type}</h5></>
                                                                    : null}
                                                            </p>
                                                        </Col>
                                                        <Col md={4}>
                                                            {child.current.url ?
                                                                <Button className="fullwidth" href={child.current.url}>View</Button>
                                                                : null}
                                                        </Col>
                                                        {child.current.url ? <hr /> : null}
                                                        <Col md={12}>
                                                            {child.previous ?
                                                                <>
                                                                    <p class="bold">Description:</p>
                                                                    <p>{child.current.description}</p>
                                                                    <p class="bold">See Previous Versions:</p>

                                                                    {child.previous && child.previous.map(prev => (
                                                                        <span><a href={prev.url}>{prev.version}</a>, </span>
                                                                    ))} </>
                                                                : null}
                                                            {child.appendix ?
                                                                <>
                                                                    <p class="bold">See appendices for all versions:</p>
                                                                    {child.appendix && child.appendix.map(append => (<div className='mb-5'>
                                                                        <h4>{append.version}</h4>
                                                                        {append.children && append.children.map(appendchild => (
                                                                            <p><a href={appendchild.url}>{appendchild.name}</a></p>
                                                                        ))}
                                                                    </div>))}</>
                                                                : null}
                                                            {child.retired ?
                                                                <>
                                                                    <p class="bold">See previous versions:</p>
                                                                    {child.retired && child.retired.map(retiredmap => (<div className='mb-5'>
                                                                        <h4>{retiredmap.retire}</h4>
                                                                        {retiredmap.previous && retiredmap.previous.map(retiredprevious => (
                                                                            <span><a href={retiredprevious.url}>{retiredprevious.version}</a>, </span>
                                                                        ))}
                                                                    </div>))}</>
                                                                : null}

                                                        </Col>
                                                    </Row>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </Accordion>
                                    </>))}

                                    <Accordion id={information.appendices.tag} eventKey={information.appendices.tag}  defaultActiveKey={loc.length === 0 ? "empty" : loc}>
                                        <Accordion.Item eventKey={information.appendices.tag} >
                                            <Accordion.Header id={information.appendices.tag} >
                                                <div className={styles.accordionHeading}>
                                                    <div className={styles.subTopicHeading}>Appendices</div>
                                                    <div ref={target}>
                                                        {appendix === true ? <div className={styles.copyContainer}><i className="fa fa-check-circle flex"></i><div className={styles.copiedText + ' ' + "flex"}>Copied to Clipboard</div></div> :
                                                            <CopyToClipboard text={`${window.location.origin}` + `${window.location.pathname}` + "?" + `${selectedTab ? selectedTab : '1'}`  + "#" + `${information.appendices.tag}`} onCopy={handleCopy}>
                                                                <Button variant="link" className={styles.copyBtn} onClick={(e) => e.stopPropagation()}>
                                                                    <a onClick={appendixClick}>Share</a>
                                                                </Button>
                                                            </CopyToClipboard>
                                                        }
                                                    </div>
                                                </div>
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                <p>See appendices for all versions:</p>
                                                {information.appendices.appendix.map((append) => (<>
                                                    <h4 className="mt-4">{append.version}</h4>
                                                    {append.children.map((appendchild, index) => (<>
                                                        <p><a href={appendchild.url}>{appendchild.name}</a></p>
                                                    </>))}
                                                </>))}
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                    <Accordion className="mt-3" id={information.retiredmodule.tag} eventKey={information.retiredmodule.tag}  defaultActiveKey={loc.length === 0 ? "empty" : loc}>
                                        <Accordion.Item eventKey={information.retiredmodule.tag}>
                                            <AccordionHeader id={information.retiredmodule.tag}>
                                                <div className={styles.accordionHeading}>
                                                    <div className={styles.subTopicHeading}>{information.retiredmodule.indicator}</div>
                                                    <div ref={target}>
                                                        {hover === index ? <div className={styles.copyContainer}><i className="fa fa-check-circle flex"></i><div className={styles.copiedText + ' ' + "flex"}>Copied to Clipboard</div></div> :
                                                            <CopyToClipboard text={`${window.location.origin}` + `${window.location.pathname}` + "?" + `${selectedTab ? selectedTab : '1'}` + "#" + `${information.retiredmodule.tag}`} onCopy={handleCopy}>
                                                                <Button variant="link" className={styles.copyBtn} onClick={(e) => e.stopPropagation()}>
                                                                    <a onClick={() => handleMouseEnter(index)}>Share</a>
                                                                </Button>
                                                            </CopyToClipboard>
                                                        }
                                                    </div>
                                                </div>
                                            </AccordionHeader>
                                            <AccordionBody>
                                                <p>See Previous Versions: </p>
                                                {information.retiredmodule && information.retiredmodule.retired.map((retiremap) => (<>
                                                    <p><span className="mt-4">{retiremap.retire} </span>
                                                        {retiremap.previous.map((appendchild, index) => (<>
                                                            <span><a href={appendchild.url}>{appendchild.version} </a></span>
                                                        </>))}</p>
                                                </>))}
                                            </AccordionBody>
                                        </Accordion.Item>
                                    </Accordion>
                                </Tab.Pane>

                            </Tab.Content>
                        </>))}
                    </Col>
                </Row>
            </Tab.Container>
        </Container>
    </>)
}

export default AllMeasures;